import { WxBaseWidget } from './wxBaseWidget';

export { WxBaseWidget };
export default WxBaseWidget;
